var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mx-3", staticStyle: { width: "50%" } },
        [
          _c("v-text-field", {
            attrs: {
              "append-icon": "search",
              label: "Buscar...",
              "single-line": "",
              "hide-details": ""
            },
            on: { input: _vm.onFilterTextBoxChanged },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      ),
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "derecha",
            fn: function() {
              return [
                _c("ExportarAgGridButton", {
                  attrs: {
                    permisoAccion: _vm.accionExportar,
                    "column-defs": _vm.gridOptions.columnDefs,
                    rowData: _vm.lstInformesGenerados,
                    "exported-file-name": "ProgramacionDeInformes"
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("MantenedorGrid", {
        attrs: {
          "grid-options": _vm.gridOptions,
          "row-data": _vm.lstInformesGenerados,
          "funcionalidad-id": _vm.funcionalidad
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }